import { useContext, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { GlobalContext } from "../Context/globalContext";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { BsBoxArrowRight } from "react-icons/bs";

export const Header = () => {

    const globalContext = useContext(GlobalContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!globalContext.loggedIn) {
            navigate('/');
        }
    }, [globalContext.loggedIn, navigate]);

    const logout = async () => {
        globalContext.setLoader(true);
        await firebaseLogout();
        globalContext.setLoader(false);
        globalContext.setLoggedIn(false);
        globalContext.setUserEmail('');
        globalContext.setUserRole('');
        navigate('/');
        setTimeout(() => { toast.success('Logged Out Successfully.'); }, 500);
    }

    const firebaseLogout = async () => {
        try {
            await signOut(auth);
            console.log("User logged out");
        } catch (error) {
            console.error("Logout Error:", error.message);
        }
    };

    return (
        <header id="header" className="header fixed-top d-flex align-items-center">
            <div className="d-flex align-items-center justify-content-between">
                <Link className="logo d-flex align-items-center" to="/">
                    <span className="d-none d-lg-block"><img src={require("../Assets/img/logo.png")} alt="mindreset" /></span>
                </Link>
                {/* <AiOutlineMenu className="toggle-sidebar-btn" onClick={(e) => document.body.classList.toggle('toggle-sidebar')} /> */}
            </div>
            <nav className="header-nav ms-auto">
                <ul className="d-flex align-items-center">
                    <li className="nav-item dropdown pe-3">
                        <a className="nav-link nav-profile d-flex align-items-center pe-0" style={{ cursor: "pointer" }} data-bs-toggle="dropdown">
                            <img src={require('../Assets/img/profile.png')} alt="Profile" className="rounded-circle" />
                        </a>
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                            <li className="dropdown-header">
                                {globalContext.userEmail}
                            </li>
                            <li>
                                <hr className="dropdown-divider" />
                            </li>
                            <li>
                                <a className="dropdown-item d-flex align-items-center drop-options" onClick={(e) => logout(e)}>
                                    <BsBoxArrowRight className="me-2" aria-hidden="true" />
                                    <span>Sign Out</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav >
        </header >

    )

}
